<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div class="py-12 px-4">
      <nav class="flex justify-between items-center mb-4">
        <h1 class="text-2xl text-theme-1">
          สมาชิก
        </h1>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-4 lg:col-span-3" v-if="getAllowActionByCurrRole('search-member')">
          <MemberFilter />
        </div>
        <div class="col-span-12" :class="{'md:col-span-8 lg:col-span-9': getAllowActionByCurrRole('search-member')}">
          <FilterSummary :items="filterSummaryStore" v-if="getAllowActionByCurrRole('search-member')" />
          <MemberDatatable :filter="filterValue" />
        </div>
      </div>
    </div>
  </template-layout>
</template>

<script setup>
import MemberFilter from "@/components/filter-search/MemberFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import MemberDatatable from "./Datatable.vue"
import { computed, reactive, watch } from "vue";
import { useStore } from "vuex";
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import { getAllowActionByCurrRole } from "@/utils/get-roles"
const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["memberFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["memberFilter/getFilterForApi"]);
const breadcrumbComputed = reactive([{
  name: "สมาชิก",
  active: true
}])

</script>
